import React from 'react';
import styled from 'styled-components';
import SwipeableViews from 'react-swipeable-views';


const StyledSwipeableViews = styled(SwipeableViews)`
    /* height: 100%; */
    display: flex;
    flex: 1;

    /* div > {
        height: 100%
    } */
    .react-swipeable-view-container {
        width: 100%;

    }
`;

export default StyledSwipeableViews;


// WEBPACK FOOTER //
// ./src/js/components/StyledSwipeableViews/index.jsx